import Rule from './Rule'

// default validation methods
const isString = (value) => typeof value === 'string'
const isText = (value) => !(/\d/.test(value)) && !(/[!@#$%^&*(),.?":{}|<>]/.test(value))
const isNotEmpty = (value) => value !== '' && value !== null && typeof value !== 'undefined'
const isInt = (value) => Number.isInteger(value)
const isEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
const isValidPassword = (password) => (/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+-|\}{[\];:?><'""]).{8,30}/.test(password))

const defaultRules = [
  new Rule('isString', isString, 'This value must be type of String'),
  new Rule('required', isNotEmpty, 'Please provide'),
  new Rule('isInt', isInt, 'This value must be type of Integer'),
  new Rule('isText', isText, 'Please check for numbers or special characters and remove.'),
  new Rule('isEmail', isEmail, 'Please check email format: yourname@example.com'),
  new Rule('isValidPassword', isValidPassword, 'Passwords must be at least 8 characters long and contain an uppercase letter, a lowercase letter, a number and a symbol.')
]

export default defaultRules
